/*
 * @Author       : a大师兄
 * @Date         : 2021-06-02 16:41:14
 * @LastEditors  : a大师兄
 * @LastEditTime : 2021-11-16 14:44:40
 * @Description  :微信分享
 */
import { getJSSDKParams } from '@/api/ApiWx.js'

//存储链接的签名信息
const signMap = new Map()
let jsApiList = [
  'showMenuItems',
  'hideAllNonBaseMenuItem',
  'updateTimelineShareData',
  'updateAppMessageShareData',
  'onMenuShareTimeline', //分享到朋友圈
  'onMenuShareAppMessage', //分享给朋友
]
// 默认wx分享配置
const shareWXParams = params => {
  return {
    jsApiList: jsApiList,
    ready: () => {
      return new Promise(resolve => {
        let desc = document.querySelector('meta[name=description]')
          ? document.querySelector('meta[name=description]').content
          : ''
        let share = {
          title: params.title || document.title, // 分享标题
          link: params.shareUrl || window.location.href, // 分享链接
          imgUrl:
            params.imgUrl ||
            window.config.resourceServer + '/images/icon/logo.png', // 分享图标
          desc: params.desc || desc,
          success: function () {
            params.success && params.success()
            // 用户确认分享后执行的回调函数
            console.log('用户点击了分享')
          },
          cancel: function () {
            params.cancel && params.cancel()
            // 用户取消分享后执行的回调函数
          },
        }
        // 隐藏所有非基础按钮接口
        // 只显示朋友圈跟发送好友
        window.wx.showMenuItems({
          menuList: ['menuItem:share:timeline', 'menuItem:share:appMessage'],
        })
        // 使用老版本分享--支持分享成功回调方法
        window.wx.onMenuShareTimeline(share) //分享到朋友圈
        window.wx.onMenuShareAppMessage(share) //转发给好友
        window.wx.updateAppMessageShareData(share)
        // 分享到朋友圈,分享到QQ空间
        window.wx.updateTimelineShareData(share)

        resolve()
      })
    },
  }
}


const _wxConfigJSSDK = (shareSign, params) => {
  window.wx.config({
    beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: shareSign.appId, // 必填，公众号的唯一标识
    timestamp: shareSign.timestamp, // 必填，生成签名的时间戳
    nonceStr: shareSign.noncestr, // 必填，生成签名的随机串
    signature: shareSign.signature, // 必填，签名，见附录1
    // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    jsApiList: params.jsApiList,
  })

  window.wx.ready(function () {
    console.log('-----------------已经正确的重新加载了jssdk-----------------')
    if (params && params.ready) {
      params.ready(params)
    }
  })
  window.wx.error(function () {
  })
}
// 禁止分享wx配置
const noShareWXParams = {
  jsApiList: jsApiList,
  ready: () => {
    return new Promise(resolve => {
      // 隐藏按钮
      window.wx.hideAllNonBaseMenuItem()
      resolve()
    })
  },
}

// 初始微信功能
export const initWXShare = function (params) {
  if (!params) {
    return
  }
  let url = window.location.href
  const u = navigator.userAgent.toLowerCase()
  //如果不是ios或者不是微信浏览器或者是企业微信浏览器
  if (!(
    u.indexOf('like mac os x') < 0 ||
    u.match(/MicroMessenger/i) != 'micromessenger' ||
    u.match(/wxwork/i) == 'wxwork'
  )) {
    url = sessionStorage.getItem('originUrl') // 用于ios分享
  }
  // 禁止分享
  params = !params.isShare ? noShareWXParams : shareWXParams(params)
  // 解决IOS只保留首次进入页面的URL的问题
  //判断是否已经签名了
  if (signMap.has(url)) {
    _wxConfigJSSDK(signMap.get(url), params)
  } else {
    return new Promise(() => {
      getJSSDKParams({
        url,
      }).then(res => {
        if (res.code === '200') {
          const sign = res.data
          signMap.set(url, sign)
          console.log('开始调用wxsdk')
          _wxConfigJSSDK(sign, params)
        }
      })
    })
  }
}


